/**
 * @desc 新增管理域(新）
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id?: number;
  /** 管理域id */
  orgId?: string;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/web/base/addBase',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/web/base/addBase',

    params,
  });
}
